import { AppSetupDb } from 'lib/cosmos/app-setup/appSetupDb.js';
import { of } from 'rxjs';
import { ViewAnalyticsComponent } from 'src/app/modules/analytics/view-analytics.component.js';
import { ViewReferrerAnalyticsComponent } from 'src/app/modules/analytics/view-referrer-analytics.component.js';
import { ViewTimezoneAnalyticsComponent } from 'src/app/modules/analytics/view-timezone-analytics.component.js';
import {
	ICoreRoutes,
	IPageMetadata,
	ITypeRoute,
	ITypeRouteAction,
	RouteInitializer
} from '../../pages/type-routes/type-route.models.js';

export interface IAdminAnalyticsRoutes extends ICoreRoutes {
	analytics: ITypeRoute<
		AppSetupDb.IAppSetupItem,
		{
			view: ITypeRouteAction<undefined>;
			timezone: ITypeRouteAction<undefined>;
			referrer: ITypeRouteAction<undefined>;
		}
	>;
}

export const adminAnalyticsRoutes: RouteInitializer<IAdminAnalyticsRoutes> = {
	analytics: {
		mainPath: 'admin',
		uniqueId: 'analytics',
		parentRoutes: (context) => [],
		loadSharedData: (context) => {
			return of(undefined);
		},
		menuItems: (context) => [
			{
				title: 'Analytics',
				iconType: 'analytics',
				routerLink: context.dependencies.navigateService
					.actionRoute((routes) => routes.adminAnalyticsRoutes.analytics.children.view)
					.getUrl()
			},
			{
				title: 'Timezones Analytics',
				iconType: 'timezone',
				routerLink: context.dependencies.navigateService
					.actionRoute((routes) => routes.adminAnalyticsRoutes.analytics.children.timezone)
					.getUrl()
			},
			{
				title: 'Referrer analytics',
				iconType: 'browser',
				routerLink: context.dependencies.navigateService
					.actionRoute((routes) => routes.adminAnalyticsRoutes.analytics.children.referrer)
					.getUrl()
			}
		],
		children: {
			view: {
				uniqueId: `viewAnalytics`,
				component: ViewAnalyticsComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: `Analytics`
					};
					return metadata;
				}
			},
			timezone: {
				uniqueId: `viewTimezoneAnalytics`,
				component: ViewTimezoneAnalyticsComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: `Timezone analytics`
					};
					return metadata;
				}
			},
			referrer: {
				uniqueId: `viewReferrerAnalytics`,
				component: ViewReferrerAnalyticsComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: `Referrer analytics`
					};
					return metadata;
				}
			}
		}
	}
};
